<template>
  <div>
    <div class="contents">
      <h4 class="subtitle">
        <!-- <span class="badge minigame-type">
          {{ eventinfo.awardtype | awardtype }}
        </span> -->
        <span class="badge minigame-event-type">
          {{ event_type(eventinfo.award_fk) }}
        </span>        
        <p class="minigame-title">{{ eventinfo.title }}</p>
      </h4>
      <p class="mb-4 lh-sm" v-if="eventinfo.standard_point != 0">
        <span> {{ $t("title.common.point_allocation") }} : </span>
        <span class="text-point-sp">
          {{ $t("title.common.standard_point") }}
        </span>
      </p>
      <b-form @submit="onSubmit">
        <div class="filter-group row row-cols-1 row-cols-sm-auto g-2">
          <!-- <div class="date-search mb-0">
            <input
              type="date"
              class="form-control-lg"
              v-model="searchData.startdate"
            />
            <input
              type="date"
              class="form-control-lg"
              v-model="searchData.enddate"
            />
          </div> -->
          <div class="select">
            <select
              class="form-select-lg"
              aria-label=".form-select-lg example"
              v-model="searchData.searchtype"
            >
              <option value="1">
                {{ $t("filter.event.minigame") }}
                {{ $t("filter.common.title") }}
              </option>
              <option value="2">{{ $t("filter.common.course") }}</option>
              <option value="3">{{ $t("filter.common.nickname") }}</option>
              <!-- <option value="4">player name</option> -->
            </select>
          </div>

          <div class="search-input">
            <input
              type="text"
              class="form-control-lg"
              v-model="searchData.searchname"
            />
            <input
              class="btn btn-primary btn-lg search"
              type="submit"
              value=""
            />
          </div>
        </div>
      </b-form>
      <table class="table board toggle-xl">
        <thead>
          <tr>
            <!-- <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.minigame") }} {{ $t("title.common.type") }}
            </th>
            <th class="col-auto">
              {{ $t("title.common.minigame") }} {{ $t("title.common.title") }}
            </th> -->
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.winner") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.location") }}
            </th>
            <!-- <th class="col-auto d-none d-lg-table-cell">Simulator No.</th> -->
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.course") }}({{ $t("title.common.hole") }})
            </th>
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.prizes") }}
            </th>
            <th
              class="col-auto d-none d-lg-table-cell"
              v-if="eventinfo.award_fk > 8"
            >
              {{ $t("title.golfcourse.distance") }}
            </th>
            <th
              class="col-auto d-none d-lg-table-cell"
              v-if="eventinfo.standard_point != 0"
            >
              {{ $t("title.common.standard_point") }}
            </th>
            <!-- <th class="col-auto d-none d-lg-table-cell">Control</th> -->
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="data_yn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <!-- <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
              <td class="col-auto d-none d-lg-table-cell">
                {{ event_type(item.type) }}
              </td>
              <td class="col-auto">{{ item.title }}</td> -->
              <td class="col-auto d-lg-table-cell text-start">
                <MemberInfo
                  :nickname="item.nickname"
                  :playerno="item.playerno"
                  :member_img="item.member_img"
                  :badge_img="item.badge_img"
                  :displayText="item.nickname || item.playerid"
                />
              </td>
              <td class="col-auto d-none d-lg-table-cell text-date">
                {{ item.timezone_date | dateformat }}
              </td>
              <td class="col-auto d-none d-sm-table-cell shop-name">
                {{ item.shopname }}
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                {{ item.coursename }} {{ item.subcoursename }}({{ item.hole }}H)
              </td>
              <td class="col-auto d-lg-table-cell text-prize">
                {{ item.type < 11 ? null || item.point : "Rank Prize" }}
              </td>
              <td
                class="col-auto d-none d-lg-table-cell"
                v-if="eventinfo.award_fk > 8"
              >
                <template v-if="item.record">{{ item.record }}m</template>
                <template v-else>-</template>
              </td>
              <td
                class="col-auto d-none d-lg-table-cell text-point-sp"
                v-if="eventinfo.standard_point != 0"
              >
                {{ item.standard_points | comma | suffix("P") }}
              </td>
              <!-- <td class="col-auto d-none d-lg-table-cell">
                <button
                  type="button"
                  class="btn btn-primary btn-xs"
                  @click="
                    $router.push({
                      name: 'MiniGameRank',
                      params: {
                        params: { eventno: item.eventno },
                      },
                    })
                  "
                >
                  {{ $t("participant") }}
                </button>
              </td> -->
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="6">
                <div class="toggle-content">
                  <div class="row d-lg-none">
                    <div class="col-4">{{ $t("title.common.date") }}</div>
                    <div class="col-8 text-date">
                      {{ item.timezone_date | dateformat }}
                    </div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">{{ $t("title.common.location") }}</div>
                    <div class="col-8 shop-name">
                      {{ item.shopname }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col-4">Simulator No.</div>
                    <div class="col-8">{{ item.simulatorno }}</div>
                  </div> -->
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.course") }}</div>
                    <div class="col-8">
                      {{ item.coursename }} {{ item.subcoursename }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.hole") }}</div>
                    <div class="col-8">{{ item.hole }}H</div>
                  </div>
                  <!--                   <div class="row">
                    <div class="col-4">{{ $t("title.common.prizes") }}</div>
                    <div class="col-8 text-cyan">
                      {{ item.type < 11 ? null || item.point : "Rank Prize" }}
                    </div>
                  </div> -->
                  <div class="row d-lg-none" v-if="eventinfo.award_fk > 8">
                    <div class="col-4">
                      {{ $t("title.golfcourse.distance") }}
                    </div>
                    <div class="col-8" v-if="item.record">
                      {{ item.record }}m
                    </div>
                    <div class="col-8" v-else>-</div>
                  </div>
                  <div
                    class="row d-lg-none"
                    v-if="eventinfo.standard_point != 0"
                  >
                    <div class="col-4">
                      {{ $t("title.common.standard_point") }}
                    </div>
                    <div class="col-8 text-point-sp">
                      {{ item.standard_points | comma | suffix("P") }}
                    </div>
                  </div>

                  <!-- <div class="row">
                    <div class="col-4">Control</div>
                    <div class="col-8">
                      <button
                        type="button"
                        v-if="item.type > 10"
                        class="btn btn-primary btn-xs"
                        @click="
                          $router.push({
                            name: 'MiniGameRank',
                            params: {
                              params: { eventno: item.eventno },
                            },
                          })
                        "
                      >
                        {{ $t("participant") }}
                      </button>
                    </div>
                  </div> -->
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="page_total"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="page_total > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          :aria-label="$t('button.common.list')"
          @click="$router.push({ name: 'MiniGameList' })"
          >{{ $t("button.common.list") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/event";
import { myMixin } from "@/mixin/myMixin";
import "@/filter/common";

export default {
  name: "WinningDetailList",
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          this.$dayjs().add(-1, "month").format("YYYY-MM-DD"),
        enddate:
          this.$route.query.enddate || this.$dayjs().format("YYYY-MM-DD"),
        searchtype: this.$route.query.searchtype || 2,
        searchname: this.$route.query.searchname || "",
        type: this.$route.query.type || 0,
        pageno: this.$route.query.pageno || 1,
        eventno: this.$route.params.eventno || 0,
      },

      page_total: 1,
      total_cnt: 0,
      data_yn: true,
      rows: 10,
      items: [],
      view_hide: null,
      eventinfo: {},
    };
  },
  watch: {
    "$route.query": function () {
      this.searchData.pageno = parseInt(this.$route.query.page) || 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_admineventwinninglist();
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.get_admineventwinninglist();
    },
    get_admineventwinninglist() {
      ax.get_admineventwinninglist(this.searchData, (flag, data) => {
        console.log(flag, data);
        if (flag) {
          if (data.eventwvinninglistcnt <= 0) {
            this.data_yn = false;
          } else {
            this.data_yn = true;
          }
          this.total_cnt = data.eventwvinninglistcnt;
          this.page_total = Math.ceil(data.eventwvinninglistcnt / this.rows);
          this.items = data.eventwvinninglist;
          this.eventinfo = data.eventinfo;
        } else {
          this.data_yn = false;
          this.page_total = 0;
          // alert(data);
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
  created() {
    this.get_admineventwinninglist();
  },
  watch: {
    // "$route.query": function () {
    //   this.searchData.pageno = parseInt(this.$route.query.page) || 1;
    //   this.get_eventwinningranklist();
    // },
    searchData: {
      handler: function (val, oldVal) {
        this.$store.commit("setSearchData", {
          [this.$route.name]: val,
        });
        this.get_admineventwinninglist();
      },
      deep: true,
    },
  },
  mixins: [myMixin],
};
</script>
